import { createContext, useReducer, useEffect } from 'react';
import axios from '../functions/axios';
import { compareObjects } from '../functions/functions';
import { getDiff } from 'recursive-diff';

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, user: action.payload };
    case 'LOGOUT':
      return { ...state, user: null };
    case 'AUTH_READY':
      return { ...state, authReady: true };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    authReady: false,
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (user) {
      dispatch({ type: 'LOGIN', payload: user });
      axios.defaults.headers.common['Authorization'] = user.apiToken;
    }

    const controller = new AbortController();
    const { signal } = controller;

    const fetchUserData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const { data: userData } = await axios.get('/me', { signal });

        if (!userData.email || !userData.apiToken || userData.removed) {
          localStorage.removeItem('user');
          dispatch({ type: 'LOGOUT' });
          return;
        }

        if (getDiff(user, userData).length !== 0) {
          localStorage.setItem('user', JSON.stringify(userData));
          dispatch({ type: 'LOGIN', payload: userData });

          if (userData.apiToken) {
            axios.defaults.headers.common['Authorization'] = userData.apiToken;
          }
        }
      } catch (error) {
        console.error('Failed to fetch user data:', error);
      }
    };

    if (user) {
      fetchUserData();
    }

    dispatch({ type: 'AUTH_READY' });

    const intervalId = setInterval(() => {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      if (currentUser) {
        fetchUserData();
      }
    }, 60_000);

    return () => {
      clearInterval(intervalId);
      controller.abort();
    };
  }, []);

  return <AuthContext.Provider value={{ ...state, dispatch }}>{children}</AuthContext.Provider>;
};
